import React from 'react'
import Modal from '../../modals/wrapper'
import { Form, Button } from 'react-bootstrap'
import { get } from 'lodash'
import Topic from './topic'
import Content from './content'
import Users from './users'
import useCreateDiscussion from './use-create-discussion'

const DiscussionCreationModal = ({
    users: inputUsers = [],
    topic: inputTopic,
    onClose = () => {}
}) => {
    const [conversation, setConversation] = React.useState({ topic: inputTopic, users: inputUsers })

    const {
        topic = '',
        users = [],
        content = ''
    } = conversation

    const {
        createDiscussion,
        isCreatingDiscussion
    } = useCreateDiscussion({
        topic,
        content,
        users,
        onSuccess: onClose
    })

    const validRecipients = get(conversation, 'users', []).length > 1
    const validTopic = Boolean(get(conversation, 'topic', '').trim())
    const validContent = Boolean(get(conversation, 'content', '').trim())
    const canSend = validRecipients && validTopic && validContent

    return (
        <Modal
            onHide={onClose}
            closeButton
            closeStyle={{ color: 'white' }}
        >
            <Modal.Header>
                Compose Message
            </Modal.Header>
            <Form style={{ padding: '20px' }}>
                <Users
                    value={conversation.users}
                />
                <Topic
                    value={conversation.topic}
                    onChange={topic => setConversation({ ...conversation, topic})}
                />
                <Content
                    value={conversation.content}
                    onChange={content => setConversation({ ...conversation, content})}
                />
            </Form>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    padding: '0px 20px 20px'
                }}
            >
                <Button
                    disabled={!canSend || isCreatingDiscussion}
                    block
                    onClick={() => createDiscussion()}
                >
                    {isCreatingDiscussion ? 'SENDING...' : 'SEND'}
                </Button>
            </div>
        </Modal>
    )
}

export default DiscussionCreationModal
